import { createReducer } from '@reduxjs/toolkit';
import { PopUpTypes } from '../entities';
import {
  closePopUp,
  openCameraAccessAlertPopUp,
  openErrorPopUp,
  openScanProcessPopUp,
  openUploadProcessPopUp,
} from './actions';
import { popUpsInitialState } from './state';

export const popUpsReducer = createReducer(popUpsInitialState, (builder) => {
  builder
    .addCase(closePopUp, (state) => {
      state.type = PopUpTypes.NONE;
    })
    .addCase(openCameraAccessAlertPopUp, (state) => {
      state.type = PopUpTypes.CAMERA_ACCESS_ALERT;
    })
    .addCase(openScanProcessPopUp, (state) => {
      state.type = PopUpTypes.SCAN_PROCESS;
    })
    .addCase(openUploadProcessPopUp, (state) => {
      state.type = PopUpTypes.UPLOAD_PROCESS;
    })
    .addCase(openErrorPopUp, (state) => {
      state.type = PopUpTypes.ERROR;
    });
});
